import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const Kpi = ({ label, value, sub, testid }) => (
  <Card className="p-4" data-testid={testid}>
    <p className="font-mono-erp text-[10px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <p className="mt-1 font-display text-2xl font-bold">{value}</p>
    {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
  </Card>
);

const Daily = ({ rows }) => (
  <Card className="p-6" data-testid="cutting-daily-chart">
    <h3 className="mb-4 font-display text-lg font-semibold">Capi tagliati per giorno</h3>
    {rows.length === 0 ? <p className="text-sm text-muted-foreground">Nessun taglio registrato nel periodo.</p> : (
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={rows.map((d) => ({ ...d, label: `${d.date.slice(8, 10)}/${d.date.slice(5, 7)}` }))}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="label" stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} />
          <YAxis stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} allowDecimals={false} />
          <Tooltip contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 13 }} cursor={{ fill: "hsl(var(--accent))" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="pieces" name="Capi produzione" stackId="a" fill="hsl(var(--primary))" />
          <Bar dataKey="samples" name="Campioni" stackId="a" fill="#38bdf8" />
          <Bar dataKey="markers" name="Grafici" fill="#a3e635" />
        </BarChart>
      </ResponsiveContainer>
    )}
  </Card>
);

const Cutters = ({ rows }) => rows.length > 0 && (
  <Card className="p-6" data-testid="cutting-by-cutter">
    <h3 className="mb-3 font-display text-lg font-semibold">Per chi ha tagliato</h3>
    <div className="space-y-2">
      {rows.map((r) => (
        <div key={r.name} className="flex flex-wrap items-center justify-between gap-2 text-sm">
          <span className="font-medium">{r.name}</span>
          <span className="text-xs text-muted-foreground"><b className="text-foreground">{num(r.pieces)} capi</b> · {num(r.markers)} grafici · {num(r.samples)} campioni · {r.days} giorni</span>
        </div>
      ))}
    </div>
  </Card>
);

export const CuttingStats = ({ s }) => (
  <div className="space-y-4" data-testid="cutting-stats">
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
      <Kpi label="Capi tagliati" value={num(s.pieces)} sub={`${num(s.pieces_per_day)} al giorno · ${s.days_worked} giorni`} testid="cutting-kpi-pieces" />
      <Kpi label="Grafici tagliati" value={num(s.markers)} sub={`${num(s.pieces_per_marker)} capi per grafico`} testid="cutting-kpi-markers" />
      <Kpi label="Articoli tagliati" value={num(s.articles)} sub={`${num(s.markers_per_article)} grafici per articolo`} testid="cutting-kpi-articles" />
      <Kpi label="Tessuto usato" value={`${num(s.fabric_meters)} m`} sub={`${num(s.meters_per_piece)} m per capo`} testid="cutting-kpi-meters" />
      <Kpi label="Campioni" value={num(s.samples.pieces)} sub={`${s.samples.sessions} tagli · ${s.samples.articles} articoli`} testid="cutting-kpi-samples" />
      <Kpi label="Da tagliare" value={num(s.queue.pieces_left)} sub={`${s.queue.open} articoli · ${s.queue.by_priority.alta} urgenti${s.queue.overdue ? ` · ${s.queue.overdue} in ritardo` : ""}`} testid="cutting-kpi-queue" />
    </div>
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
      <div className="xl:col-span-2"><Daily rows={s.daily} /></div>
      <Cutters rows={s.by_cutter} />
    </div>
  </div>
);
